
import Home from "./pages/Home/Home";
import Photogallery from "./pages/Gallery/Photogallery";
function App() {
  return(<>
  <Home /> 
  <Photogallery/>;
 </>
  )
}

export default App;